import { message } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import CompulsoryImage from 'assets/images/driver-portal/preview/compulsory.png';
import ConsentImage from 'assets/images/driver-portal/preview/consent.png';
import VehicleInsurnaceImage from 'assets/images/driver-portal/preview/vehicle-insurance.png';
import VehicleRegistrationImage from 'assets/images/driver-portal/preview/vehicle-registration.png';
import { Button, FormItem, Select } from 'components';
import { theme } from 'configs/styled';
import Divider from 'containers/DriverPortalPage/components/Divider';
import Title from 'containers/DriverPortalPage/components/Title';
import { FormikProps, FormikValues, getIn, useFormik } from 'formik';
import usePrompt from 'hooks/usePrompt';
import { useQueryParams } from 'hooks/useQueryParams';
import { useUpdateExpireDateImages } from 'hooks/useUpdateExpireDateImages';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import {
  addressService,
  authenticationService,
  documentReaderService,
  mainService,
  uploadService,
} from 'services/driverPortal';
import { STATUS_RESPONSE } from 'services/driverPortal/DriverPortal.interface';
import { appendOcrMetadata } from 'utils/appendOcrMetadata';
import * as Yup from 'yup';
import Loading from '../../../../components/ReturnOrderModal/Loading';
import { ReaderType } from '../../../../services/driverPortal/documentReader/DocumentReaderService';
import { isPdfFile } from '../../../../utils/isFilePdf';
import DriverPortalLayout from '../../components/DriverPortalLayout';
import { ISelectAddressProps } from '../PersonalInformationPage';
import ConfirmReturnModal from '../components/ConfirmReturnModal';
import HeaderPortal from '../components/HeaderPortal';
import Information from '../components/Information';
import ReturnButton from '../components/ReturnButton';
import UploadImageForm from '../components/UploadImageForm';

interface IVehicleInformationImage {
  image?: string;
  createdAt?: string;
}

interface IVehicleInformationRequest {
  serviceType?: string;
  ownership?: string;
  registrationType?: string;
  registrationDocument: IVehicleInformationImage;
  carTaxStickerDocument: IVehicleInformationImage;
  vehicleInsuranceDocument: IVehicleInformationImage;
  consentFormDocument?: IVehicleInformationImage;
  ownerInsurance?: string;
  issueDate?: string;
  expiryDate?: string;
  agreementMadeOn?: string;
  policyIssuedOn?: string;
  status?: string;

  taxExpiryDate?: string;

  insuranceCompanyName?: string;
  registrationNumber?: string;
  policyHolderName?: string;
  registrationNumberTax?: string;
  licensePlateNumber?: string;

  carBrand?: string;
  vehicleBrand?: string;
  vehicleModelName?: string;
  vehicleModelYear?: string;
  vehicleColor?: string;
  vehicleType?: string;
  vehicleChassisNumber?: string;
  vehicleEngineNumber?: string;
  owner?: string;
  vehicleRegisterDate?: string;
  vehicleLicenseNumber?: string;
  vehicleLicenseProvince?: string;

  actChasissNumber?: string;
  actLicensePlateNumber?: string;
  actRegisterNumber?: string;

  fileDataRegis?: any;
  fileDataTax?: any;
  fileDataAct?: any;
  error?: IError;
}

interface IVehicleInformationNewRequest {
  serviceType?: string;
  ownership?: string;
  registrationType?: string;
  registrationDocument: IVehicleInformationImage;
  carTaxStickerDocument: IVehicleInformationImage;
  vehicleInsuranceDocument: IVehicleInformationImage;
  consentFormDocument?: IVehicleInformationImage;

  fileDataRegis?: any;
  fileDataTax?: any;
  fileDataAct?: any;
  error?: IError;
  //เล่มรถ
  regisOwner?: string;
  regisVehicleBrandEn?: string;
  regisVehicleBrandTh?: string;
  regisVehicleChassisNumber?: string;
  regisVehicleColor?: string;
  regisVehicleEngineNumber?: string;
  regisVehicleLicenseNumber?: string;
  regisVehicleLicenseProvince?: string;
  regisVehicleModelName?: string;
  regisVehicleModelYear?: string;
  regisVehicleOwner?: string;
  regisVehicleRegisterDate?: string;
  regisVehicleType?: string;
  //ภาษี
  taxCarBrandEn?: string;
  taxCarBrandTh?: string;
  taxExpiryDate?: string;
  taxRegistrationNumber?: string;
  //พรบ.
  actChasissNumber?: string;
  actLicensePlateNumber?: string;
  actCompanyName: string;
  actContractDate: string;
  actEndDate: string;
  actProcessDate: string;
  actStartDate: string;
  actPolicyHolderName: string;
  actRegistrationNumber: string;
}

interface IError {
  regisError?: string;
  taxError?: string;
  actError?: string;
}

interface IVehicleInformationImageUpload {
  registrationDocument?: FormData;
  carTaxStickerDocument?: FormData;
  vehicleInsuranceDocument?: FormData;
  consentFormDocument?: FormData;
}

enum ImageTypes {
  REGISTRATION_DOCUMENT = 'registrationDocument',
  CAR_TAX_STICKER_DOCUMENT = 'carTaxStickerDocument',
  VEHICLE_INSURANCE_DOCUMENT = 'vehicleInsuranceDocument',
  CONSENT_FORM_DOCUMENT = 'consentFormDocument',
}

const imageKeys: ImageTypes[] = [
  ImageTypes.REGISTRATION_DOCUMENT,
  ImageTypes.CAR_TAX_STICKER_DOCUMENT,
  ImageTypes.VEHICLE_INSURANCE_DOCUMENT,
  ImageTypes.CONSENT_FORM_DOCUMENT,
];

type VehicleInfoExtra = {
  insuranceCompanyName?: string;
  registrationNumber?: string;
  policyHolderName?: string;
  registrationNumberTax?: string;
  licensePlateNumber?: string;
  carBrand?: string;
  vehicleBrand?: string;
  vehicleModelName?: string;
  vehicleModelYear?: string;
  vehicleColor?: string;
  vehicleType?: string;
  vehicleChassisNumber?: string;
  vehicleEngineNumber?: string;
  owner?: string;
  vehicleRegisterDate?: string;
  vehicleLicenseNumber?: string;
  vehicleLicenseProvince?: string;

  registrationDocument?: { image?: string; createdAt?: string };
  carTaxStickerDocument?: { image?: string; createdAt?: string };
  vehicleInsuranceDocument?: { image?: string; createdAt?: string };
  consentFormDocument?: { image?: string; createdAt?: string };
  ownerInsurance?: string;
  issueDate?: string;
  expiryDate?: string;
  agreementMadeOn?: string;
  policyIssuedOn?: string;
};

const STATUS_TH_MAP: Record<string, string> = {
  none_data: 'ยังไม่มีข้อมูล',
  waiting: 'รอตรวจสอบ',
  document_invalid: 'เอกสารไม่ถูกต้อง',
  document_invalied: 'เอกสารไม่ถูกต้อง', // กันสะกดผิด
  approved: 'อนุมัติ',
  expired: 'หมดอายุ',
};

const toThaiStatus = (code?: string) =>
  STATUS_TH_MAP[(code ?? '').trim().toLowerCase()] ?? '';

const folderType = 'vehicle-information';

const convertToLocalDateTime = (isoString: any) => {
  if (!isoString) return '';
  return moment(isoString).format('YYYY-MM-DDTHH:mm');
};

const convertDateTimeToUTC = (localDateTime: string) => {
  if (!localDateTime) return '';
  return moment(localDateTime).utc().format();
};

const toDateOnly = (local?: string) =>
  local ? moment(local).format('YYYY-MM-DD') : '';

const validateVehicleInformation = Yup.object().shape({
  ownership: Yup.string().required('กรุณาเลือกกรรมสิทธิ์เจ้าของรถ'),
  serviceType: Yup.string().required('กรุณาเลือกประเภทรถ'),
  registrationType: Yup.string().required('กรุณาเลือกประเภทป้ายทะเบียนรถ'),
  registrationDocument: Yup.object().shape({
    image: Yup.string().required('กรุณาอัพโหลดเล่มทะเบียนรถ'),
  }),
  carTaxStickerDocument: Yup.object().shape({
    image: Yup.string().required('กรุณาอัพโหลดรูปป้ายวงกลม/ใบเสียภาษี'),
  }),
  vehicleInsuranceDocument: Yup.object().shape({
    image: Yup.string().required('กรุณาอัพโหลดรูป พรบ.'),
  }),
  consentFormDocument: Yup.object().when('ownership', (ownership: string) => {
    if (ownership === 'รถยืม') {
      return Yup.object().shape({
        image: Yup.string().required('กรุณาอัพโหลดเอกสารยินยอมจากเจ้าของรถ'),
      });
    } else {
      return Yup.object().shape({
        image: Yup.string(),
      });
    }
  }),
});

const pickId = (
  options: Array<{ _id: string; title: string; value: string }>,
  val?: string,
) => {
  if (!val) return undefined;
  const f = options.find(o => o.title === val || o.value === val);
  return f ? Number(f._id) : undefined;
};

const VehicleInformationPage: React.FC = () => {
  const { search, pushUrl } = useQueryParams();
  const { userId, accessToken } = authenticationService.getUserToken();
  const [disableEdit, setDisableEdit] = useState(false);
  const [imageDeletionFiles, setImageDeletionFiles] = useState<UploadFile[]>(
    [],
  );
  const [consentFormDocument, setConsentFormDocument] = useState(false);
  const [truckType, setTruckType] = useState<ISelectAddressProps[]>([]);
  const [plateColor, setPlateColor] = useState<ISelectAddressProps[]>([]);
  const [vehicleType, setVehicleType] = useState<ISelectAddressProps[]>([]);
  const [ocrLoading, setOcrLoading] = useState(false);

  const [statusVehicleInfo, setStatusVehicleInfo] = useState<string>('');
  const [statusTax, setStatusTax] = useState<string>('');
  const [statusAct, setStatusAct] = useState<string>('');
  const [saveLoading, setSaveLoading] = React.useState(false);

  const [fileVehicleInfo, setFileVehicleInfo] = useState<string>('');
  const [fileTax, setFileTax] = useState<string>('');
  const [fileAct, setFileAct] = useState<string>('');

  const [isApprovedVehicle, setIsApprovedVehicle] = useState(false);
  const [isApprovedTax, setIsApprovedTax] = useState(false);
  const [isApprovedAct, setIsApprovedAct] = useState(false);

  const [isShowModal, setIsShowModal] = useState(false);
  const [, setShowPrompt] = usePrompt();
  const [formDirty, setFormDirty] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState<
    IVehicleInformationImageUpload
  >({});

  const { updateByFiles } = useUpdateExpireDateImages();

  const goToMainPage = () => {
    pushUrl('/', search);
  };

  const goToLoginPage = () => {
    pushUrl('/login', search);
  };

  useEffect(() => {
    const { accessToken } = authenticationService.getUserToken() || {};
    if (!accessToken) {
      pushUrl('/login', search);
    }
  }, [pushUrl, search]);

  const uploadImage = async (
    files: IVehicleInformationImageUpload,
    key: ImageTypes,
    formValues: IVehicleInformationRequest,
    createdAt: string,
  ) => {
    const uploadFile = files[key] || null;

    if (uploadFile) {
      const response = await uploadService.uploadFile(uploadFile);

      if (response.data) {
        formValues[key] = {
          image: response.data[0],
          createdAt,
        };
      }
    }
  };

  const buildVehicleInfoPayload = (
    v: IVehicleInformationRequest,
    files: IVehicleInformationImageUpload,
  ) => {
    const ownershipId = pickId(vehicleType, v.ownership);
    const serviceTypeId = pickId(truckType, v.serviceType);
    const registrationTypeId = pickId(plateColor, v.registrationType);

    const fd = new FormData();

    // helper function
    const appendIfValue = (key: string, value?: any) => {
      if (value !== undefined && value !== null && value !== '') {
        fd.append(key, value);
      }
    };

    appendIfValue('tab', 'vehicle_info');

    appendIfValue('vehicleOwnerTypeId', String(ownershipId));
    appendIfValue('vehicleTypeId', String(serviceTypeId));
    appendIfValue('vehiclePlateColorId', String(registrationTypeId));

    appendIfValue(
      'vehicleRegistrationBookRegisterDate',
      toDateOnly(v.vehicleRegisterDate),
    );
    appendIfValue(
      'vehicleRegistrationBookLicenseNumber',
      v.vehicleLicenseNumber,
    );
    appendIfValue(
      'vehicleRegistrationBookLicenseProvince',
      v.vehicleLicenseProvince,
    );
    appendIfValue('vehicleRegistrationBookType', v.vehicleType);
    appendIfValue('vehicleRegistrationBookBrand', v.vehicleBrand);
    appendIfValue('vehicleRegistrationBookModelName', v.vehicleModelName);
    appendIfValue('vehicleRegistrationBookModelYear', v.vehicleModelYear);
    appendIfValue('vehicleRegistrationBookColor', v.vehicleColor);
    appendIfValue(
      'vehicleRegistrationBookChassisNumber',
      v.vehicleChassisNumber,
    );
    appendIfValue('vehicleRegistrationBookEngineNumber', v.vehicleEngineNumber);
    appendIfValue('vehicleRegistrationBookOwner', v.owner);

    appendIfValue(
      'vehicleTaxSignRegistrationNumberTax',
      v.registrationNumberTax,
    );
    appendIfValue('vehicleTaxSignExpiryDate', toDateOnly(v.taxExpiryDate));
    appendIfValue('vehicleTaxSignCarBrand', v.carBrand);

    appendIfValue('vehicleActInsuranceCompanyName', v.insuranceCompanyName);
    appendIfValue('vehicleActRegistrationNumber', v.actRegisterNumber);
    appendIfValue('vehicleActPolicyHolderName', v.policyHolderName);
    appendIfValue('vehicleActInsuranceStartDate', toDateOnly(v.issueDate));
    appendIfValue('vehicleActInsuranceEndDate', toDateOnly(v.expiryDate));
    appendIfValue('vehicleActLicensePlateNumber', v.actLicensePlateNumber);
    appendIfValue('vehicleActVehicleChassisNumber', v.actChasissNumber);
    appendIfValue(
      'vehicleActInsuranceContractDate',
      toDateOnly(v.agreementMadeOn),
    );
    appendIfValue(
      'vehicleActInsuranceProcessDate',
      toDateOnly(v.policyIssuedOn),
    );

    appendOcrMetadata(
      fd,
      'vehicleRegistrationBookOcrMetadata',
      v.fileDataRegis,
    );
    appendOcrMetadata(fd, 'vehicleTaxSignOcrMetadata', v.fileDataTax);
    appendOcrMetadata(fd, 'vehicleActOcrMetadata', v.fileDataAct);

    // file uploads
    const f1 = files.registrationDocument?.get('files');
    const f2 = files.carTaxStickerDocument?.get('files');
    const f3 = files.vehicleInsuranceDocument?.get('files');

    if (f1) fd.append('vehicleRegistrationBook', f1 as File);
    if (f2) fd.append('vehicleTaxSign', f2 as File);
    if (f3) fd.append('vehicleAct', f3 as File);

    // Debug log
    for (const [k, val] of fd.entries()) {
      console.log(
        k,
        val instanceof File ? `${val.name} (${val.type}, ${val.size}b)` : val,
      );
    }

    return fd;
  };

  // const vehicleData = (vehicleInformation?.data ?? {}) as VehicleInfoExtra;

  const formik = useFormik<IVehicleInformationRequest>({
    initialValues: {
      error: {
        regisError: undefined,
        taxError: undefined,
        actError: undefined,
      },
      serviceType: undefined,
      ownership: undefined,
      registrationType: undefined,
      registrationDocument: {
        image: '',
        createdAt: '',
      },
      consentFormDocument: {
        image: '',
        createdAt: '',
      },
      carTaxStickerDocument: {
        image: '',
        createdAt: '',
      },
      vehicleInsuranceDocument: {
        image: '',
        createdAt: '',
      },
      insuranceCompanyName: '',
      registrationNumber: '',
      policyHolderName: '',
      registrationNumberTax: '',
      taxExpiryDate: '',
      licensePlateNumber: '',
      carBrand: '',
      vehicleBrand: '',
      vehicleModelName: '',
      vehicleModelYear: '',
      vehicleColor: '',
      vehicleChassisNumber: '',
      vehicleEngineNumber: '',
      owner: '',
      vehicleRegisterDate: '',
      vehicleLicenseNumber: '',
      vehicleLicenseProvince: '',
      fileDataRegis: null,
      fileDataTax: null,
      fileDataAct: null,
    },

    validationSchema: validateVehicleInformation,
    enableReinitialize: true,
    onSubmit: async formValues => {
      if (saveLoading) return;
      setSaveLoading(true);
      try {
        // setShowPrompt(false);

        const fd = buildVehicleInfoPayload(formValues, filesToUpload);

        const res = await addressService.updateInfo(fd);

        const out = (res as any)?.data ?? res;

        if (out?.success === false) {
          const msg =
            out?.errorMessageList?.[0] || out?.message || 'บันทึกไม่สำเร็จ';
          message.error(msg);
          return;
        }

        message.success(out?.message || 'บันทึกข้อมูลเรียบร้อยแล้ว');
        goToMainPage();
      } catch (err) {
        const status = err?.response?.status ?? err?.status;
        if (status === STATUS_RESPONSE.UNAUTHORIZED) {
          await authenticationService.logout();
          goToLoginPage();
          return;
        }
        const apiMsg =
          err?.response?.data?.message ||
          err?.message ||
          'เกิดข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้';
        message.error(apiMsg);
        console.error('[update-info:vehicle_info] error:', err);
      } finally {
        setSaveLoading(false);
      }
    },
  });

  const toLocalInput = (s?: string) => {
    if (!s) return '';
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
    const yyyy = d.getFullYear();
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const hh = pad(d.getHours());
    const mi = pad(d.getMinutes());
    return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
  };

  const ocrRegistration = async (file: File) => {
    try {
      // setOcrLoading(true);
      const res: any = await documentReaderService.readerFile(
        file,
        ReaderType.RIDER_VEHICLE_REGIST_BOOK,
      );

      if (res.status === false) {
        formik.setFieldError(
          'registrationDocument.image',
          'ไม่สามารถอ่านเล่มทะเบียนรถได้',
        );
        formik.setFieldValue('fileDataRegis', {});
        formik.setFieldValue('registrationDocument', {
          image: undefined,
        });
        formik.setFieldValue('error', {
          regisError: 'ระบบไม่สามารถอัพโหลดรูปที่ไม่ใช่เล่มทะเบียนรถได้',
        });
      } else {
        formik.setFieldValue('fileDataRegis', res);
        console.log('ocr regis=========', res);

        // formik.setFieldValue('registrationDocument', {
        //   image: res.VehicleRegistrationBook,
        // });

        formik.setFieldValue('carBrand', res.vehicle_brand_en ?? '');
        formik.setFieldValue('vehicleBrand', res.vehicle_brand_en ?? '');
        formik.setFieldValue('vehicleModelName', res.vehicle_model_name ?? '');
        formik.setFieldValue('vehicleModelYear', res.vehicle_model_year ?? '');
        formik.setFieldValue('vehicleColor', res.vehicle_color ?? '');
        formik.setFieldValue('vehicleType', res.vehicle_type ?? '');
        formik.setFieldValue(
          'vehicleChassisNumber',
          res.vehicle_chassis_number ?? '',
        );
        formik.setFieldValue(
          'vehicleEngineNumber',
          res.vehicle_engine_number ?? '',
        );
        formik.setFieldValue(
          'vehicleRegisterDate',
          res.vehicle_register_date ?? '',
        );
        formik.setFieldValue(
          'vehicleLicenseNumber',
          res.vehicle_license_number ?? '',
        );
        formik.setFieldValue(
          'vehicleLicenseProvince',
          res.vehicle_license_province ?? '',
        );
        formik.setFieldValue('owner', res.owner ?? '');
      }
    } catch (e) {
      formik.setFieldError(
        'registrationDocument.image',
        'เกิดข้อผิดพลาดในการอ่านเล่มทะเบียนรถ',
      );
      formik.setFieldValue('fileDataRegis', {});
      formik.setFieldValue('registrationDocument.image', {
        image: undefined,
      });
      formik.setFieldValue('error', {
        regisError: 'ระบบไม่สามารถอัพโหลดรูปที่ไม่ใช่เล่มทะเบียนรถได้',
      });
    } finally {
      // setOcrLoading(false);
    }
  };

  const ocrTax = async (file: File) => {
    try {
      // setOcrLoading(true);
      const res: any = await documentReaderService.readerFile(
        file,
        ReaderType.RIDER_TAX,
      );

      if (res.status === false) {
        formik.setFieldError(
          'carTaxStickerDocument.image',
          'ไม่สามารถอ่านป้ายภาษี/ใบเสียภาษีได้',
        );
        formik.setFieldValue('fileDataTax', {});
        formik.setFieldValue('carTaxStickerDocument', {
          image: undefined,
        });
        formik.setFieldValue('error', {
          taxError:
            'ระบบไม่สามารถอัพโหลดรูปที่ไม่ใช่รูปป้ายวงกลม/ใบเสียภาษีได้',
        });
      } else {
        formik.setFieldValue('fileDataTax', res);
        console.log('ocr tax=========', res);

        // formik.setFieldValue('carTaxStickerDocument', {
        //   image: res.vehicleTaxSign,
        // });

        formik.setFieldValue(
          'registrationNumberTax',
          res.registration_number ?? '',
        );
        formik.setFieldValue(
          'licensePlateNumber',
          res.registration_number ?? '',
        );
        formik.setFieldValue('taxExpiryDate', res.expiry_date ?? '');
      }
    } catch (e) {
      formik.setFieldError(
        'carTaxStickerDocument.image',
        'เกิดข้อผิดพลาดในการอ่านป้ายภาษี',
      );
      formik.setFieldValue('fileDataTax', {});
      formik.setFieldValue('carTaxStickerDocument.image', {
        image: undefined,
      });
    } finally {
      // setOcrLoading(false);
    }
  };

  const ocrAct = async (file: File) => {
    try {
      // setOcrLoading(true);
      const res: any = await documentReaderService.readerFile(
        file,
        ReaderType.RIDER_ACT,
      );

      if (res.status === false) {
        formik.setFieldError(
          'vehicleInsuranceDocument.image',
          'ไม่สามารถอ่านข้อมูล พรบ. ได้',
        );
        formik.setFieldValue('fileDataAct', {});
        formik.setFieldValue('vehicleInsuranceDocument', {
          image: undefined,
        });
        formik.setFieldValue('error', {
          actError: 'ระบบไม่สามารถอัพโหลดรูปที่ไม่ใช่ พรบ. ได้',
        });
      } else {
        formik.setFieldValue('fileDataAct', res);
        console.log('ocr act=========', res);

        // formik.setFieldValue('vehicleInsuranceDocument', {
        //   image: res.vehicleAct,
        // });
        formik.setFieldValue(
          'actRegisterNumber',
          res.registration_number ?? '',
        );
        formik.setFieldValue(
          'actLicensePlateNumber',
          res.license_plate_number ?? '',
        );
        formik.setFieldValue('actChasissNumber', res.chassis_number ?? '');
        formik.setFieldValue('ownerInsurance', res.policy_holder_name ?? '');
        // formik.setFieldValue(
        //   'registrationNumber',
        //   res.registration_number ?? '',
        // );
        formik.setFieldValue('policyHolderName', res.policy_holder_name ?? '');
        formik.setFieldValue(
          'insuranceCompanyName',
          res.insurance_company_name ?? '',
        );

        formik.setFieldValue(
          'issueDate',
          toLocalInput(res.insurance_start_date),
        );
        formik.setFieldValue(
          'expiryDate',
          toLocalInput(res.insurance_end_date),
        );
        formik.setFieldValue(
          'agreementMadeOn',
          toLocalInput(res.insurance_contract_date),
        );
        formik.setFieldValue(
          'policyIssuedOn',
          toLocalInput(res.insurance_process_date),
        );
      }
    } catch (e) {
      formik.setFieldError(
        'vehicleInsuranceDocument.image',
        'เกิดข้อผิดพลาดในการอ่าน พรบ.',
      );
      formik.setFieldValue('fileDataAct', {});
      formik.setFieldValue('vehicleInsuranceDocument.image', {
        image: undefined,
      });
      // message.error(
      //   'ขออภัย ไม่สามารถอัปโหลดได้ ระบบรองรับสมุดบัญชีของธนาคารไทยพาณิชย์ เท่านั้น',
      // );
    } finally {
      // setOcrLoading(false);
    }
  };

  const getLmTruckTypes = async () => {
    try {
      return await addressService.LmTruckTypes();
    } catch (err) {}
  };

  const getPlateColors = async () => {
    try {
      return await addressService.plateColor();
    } catch (err) {}
  };

  const getVehicleOwnerType = async () => {
    try {
      return await addressService.getVehicleOwnerType();
    } catch (err) {}
  };

  useEffect(() => {
    const getTruckTypes = async () => {
      const truckType = await getLmTruckTypes();
      if (!truckType) return;

      const _truckType = truckType.dataList.map(trucktypes => {
        return {
          _id: trucktypes.id.toString(),
          value: trucktypes.id.toString(),
          title: trucktypes.name,
        };
      });

      setTruckType(_truckType);
      // setLoadingPage(false);
    };

    const getPlateColor = async () => {
      const plateColorType = await getPlateColors();
      if (!plateColorType) return;

      const _plateColor = plateColorType.dataList.map(plateColorTypes => {
        return {
          _id: plateColorTypes.id.toString(),
          value: plateColorTypes.id.toString(),
          title: plateColorTypes.name,
        };
      });

      setPlateColor(_plateColor);
      // setLoadingPage(false);
    };

    const getVehicleTypes = async () => {
      const vehicleOwnerType = await getVehicleOwnerType();
      if (!vehicleOwnerType) return;

      const _vehicleTypes = vehicleOwnerType.dataList.map(vehicleOwnerTypes => {
        return {
          _id: vehicleOwnerTypes.id.toString(),
          value: vehicleOwnerTypes.id.toString(),
          title: vehicleOwnerTypes.name,
        };
      });

      setVehicleType(_vehicleTypes);
    };

    getTruckTypes();
    getPlateColor();
    getVehicleTypes();
  }, []);

  useEffect(() => {
    const { dirty, isSubmitting } = formik;
    const isDirty = !isSubmitting && dirty;
    setFormDirty(isDirty);

    setIsShowModal(isDirty);

    setShowPrompt(isDirty);
  }, [formik]);

  useEffect(() => {
    formik.validateForm();
  }, [formik.initialValues]);

  const errors = formik.errors || {};

  const consentFormError = errors.consentFormDocument as IVehicleInformationImage;

  const handleSelect = (key: string, value: string) => {
    formik.setFieldValue(key, value);
  };

  // useEffect(() => {
  //   getInfo();
  // }, []);

  const loadImage = async (path: string) => {
    try {
      const response = await mainService.loadImageAxios(path);
      console.log('loadImage success:', path, response);
      return response;
    } catch (e) {
      console.error('loadImage failed:', path, e);
      return null;
    }
  };

  const getInfo = async () => {
    try {
      const response = await mainService.getInfo();

      console.log(
        '========vehicle resp:',
        response?.data?.potentialLeadVehicleInfo,
      );

      if (response?.data?.potentialLeadVehicleInfo) {
        const infoData = response?.data?.potentialLeadVehicleInfo;
        console.log(
          'vehicleRegistrationBook:',
          infoData?.vehicleRegistrationBook,
        );
        setIsApprovedVehicle(infoData?.statusInfoCode === 'approved');
        setIsApprovedTax(infoData?.statusTaxSignCode === 'approved');
        setIsApprovedAct(infoData?.statusActCode === 'approved');

        const findOwner = vehicleType?.find(
          v => v._id === infoData?.vehicleOwnerTypeId?.toString(),
        );

        const findPlateColor = plateColor?.find(
          v => v._id === infoData?.vehiclePlateColorId?.toString(),
        );

        const findVehicleType = truckType?.find(
          v => v._id === infoData?.vehicleTypeId?.toString(),
        );

        formik.setFieldValue('ownership', findOwner?.title ?? undefined);
        formik.setFieldValue(
          'serviceType',
          findVehicleType?.title ?? undefined,
        );
        formik.setFieldValue(
          'registrationType',
          findPlateColor?.title ?? undefined,
        );

        formik.setFieldValue(
          'issueDate',
          convertToLocalDateTime(infoData?.vehicleActInsuranceStartDate?.date),
        );
        formik.setFieldValue(
          'expiryDate',
          convertToLocalDateTime(infoData?.vehicleActInsuranceEndDate?.date),
        );
        formik.setFieldValue(
          'agreementMadeOn',
          convertToLocalDateTime(
            infoData?.vehicleActInsuranceContractDate?.date,
          ),
        );
        formik.setFieldValue(
          'policyIssuedOn',
          convertToLocalDateTime(
            infoData?.vehicleActInsuranceProcessDate?.date,
          ),
        );
        formik.setFieldValue(
          'ownerInsurance',
          infoData?.vehicleActPolicyHolderName,
        );

        if (infoData?.vehicleRegistrationBook) {
          const imageRegis = await loadImage(infoData?.vehicleRegistrationBook);
          setFileVehicleInfo(infoData.vehicleRegistrationBook);
          formik.setFieldValue(
            'registrationDocument.image',
            imageRegis?.url || undefined,
          );
          formik.setFieldValue('fileDataRegis', {});

          console.log('set url =', imageRegis?.url);
        }

        if (infoData?.vehicleTaxSign) {
          const imageTax = await loadImage(infoData?.vehicleTaxSign);
          setFileTax(infoData.vehicleTaxSign);
          formik.setFieldValue('fileDataTax', {});
          formik.setFieldValue('carTaxStickerDocument', {
            image: imageTax ? imageTax.url : undefined,
          });
        }

        if (infoData?.vehicleAct) {
          const imageAct = await loadImage(infoData?.vehicleAct);
          setFileAct(infoData.vehicleAct);
          formik.setFieldValue('fileDataAct', {});
          formik.setFieldValue('vehicleInsuranceDocument', {
            image: imageAct ? imageAct.url : undefined,
          });
        }
        setStatusVehicleInfo(toThaiStatus(infoData?.statusInfoCode));
        setStatusTax(toThaiStatus(infoData?.statusTaxSignCode));
        setStatusAct(toThaiStatus(infoData?.statusActCode));

        console.log('========vehicle infoData:', infoData);
      }
    } catch (e) {
      console.log('===== Debug error status: ', e.toString());
    }
  };

  useEffect(() => {
    if (
      vehicleType.length > 0 &&
      plateColor.length > 0 &&
      truckType.length > 0
    ) {
      getInfo();
    }
  }, [vehicleType, plateColor, truckType]);

  const shouldDisplayErrorMessage = (key: keyof IVehicleInformationRequest) => {
    return getIn(formik.touched, key) && getIn(formik.errors, key);
  };

  const handleRemoveImage = useCallback(
    (file: UploadFile) => {
      if (!file.fileName?.match(/^blob\:/)) {
        setImageDeletionFiles([...imageDeletionFiles, file]);
      }
    },
    [imageDeletionFiles],
  );

  const handleUnauthorized = useCallback(async status => {
    if (status === STATUS_RESPONSE.UNAUTHORIZED) {
      await authenticationService.logout();
      goToMainPage();
    }
  }, []);

  const handleOnChecked2 = (event: any) => {
    setConsentFormDocument(event.target.checked);
  };

  const shouldDisabledSubmit = () => {
    return disableEdit || Object.keys(errors).length > 0;
  };

  // const convertDate = (isoString: any) => {
  //   return isoString.split('T')[0];
  // };

  const hasNewvehicleInsuranceDocument =
    !!filesToUpload.vehicleInsuranceDocument || ocrLoading;
  const hasNewcarTaxStickerDocument =
    !!filesToUpload.carTaxStickerDocument || ocrLoading;
  const hasNewregistrationDocument =
    !!filesToUpload.registrationDocument || ocrLoading;

  return (
    <>
      {((formik.values.registrationDocument.image &&
        !formik.values.fileDataRegis) ||
        (formik.values.carTaxStickerDocument.image &&
          !formik.values.fileDataTax) ||
        (formik.values.vehicleInsuranceDocument.image &&
          !formik.values.fileDataAct)) && <Loading />}

      <form onSubmit={formik.handleSubmit}>
        <HeaderPortal formik={formik as FormikProps<FormikValues>} />
        <DriverPortalLayout>
          <ReturnButton />
          <Information
            title="ข้อมูลรถ"
            description='กรุณากรอกข้อมูล และอัพโหลดเอกสารที่มีเครื่องหมาย * ให้ครบถ้วน แล้วกด "บันทึก"'
          />

          <Divider />

          <FormItem
            labelCol={{ span: 24 }}
            colon={false}
            validateStatus={
              errors?.registrationDocument?.image ||
              formik.values.error?.regisError
                ? 'error'
                : ''
            }
            help={
              formik.values.error?.regisError ??
              errors?.registrationDocument?.image
            }
          >
            <UploadImageForm
              disabled={disableEdit || isApprovedVehicle}
              title="อัพโหลดเล่มทะเบียนรถ"
              statusDocs={statusVehicleInfo || undefined}
              required
              bulletList={[
                'ไม่แก้ไขและตกแต่งรูป',
                'เห็นข้อมูลชัดเจนและครบถ้วน',
              ]}
              previewTitle="ตัวอย่างเล่มทะเบียนรถ"
              previewUrl={VehicleRegistrationImage}
              onChange={value => {
                const file = value.uploadFileForm?.get('files') as
                  | File
                  | undefined;

                setFilesToUpload({
                  ...filesToUpload,
                  registrationDocument: value.uploadFileForm,
                });

                setFileVehicleInfo(file?.name || '');

                formik.setFieldValue('registrationDocument', {
                  image: file ? URL.createObjectURL(file) : '',
                });

                if (file) {
                  ocrRegistration(file);
                }
              }}
              onRemove={file => {
                if (!file.fileName?.startsWith('blob:')) {
                  setImageDeletionFiles(prev => [...prev, file]);
                }

                setFileVehicleInfo('');
                formik.setFieldValue('registrationDocument', { image: '' });
              }}
              nameImage="เล่มทะเบียนรถ"
              pathImage={formik.values.registrationDocument.image}
              folder={folderType}
              isPdf={isPdfFile(fileVehicleInfo)}
              fileName={fileVehicleInfo}
            />
          </FormItem>

          <Divider />
          <FormItem
            labelCol={{ span: 24 }}
            colon={false}
            validateStatus={
              errors?.carTaxStickerDocument?.image ||
              formik.values.error?.taxError
                ? 'error'
                : ''
            }
            help={
              formik.values.error?.taxError ??
              errors?.carTaxStickerDocument?.image
            }
          >
            <UploadImageForm
              disabled={disableEdit || isApprovedTax}
              title="อัพโหลดรูปป้ายวงกลม/ใบเสียภาษี"
              required
              statusDocs={statusTax || undefined}
              bulletList={[
                'ไม่แก้ไขและตกแต่งรูป',
                'เห็นข้อมูลชัดเจนและครบถ้วน',
              ]}
              previewTitle="ตัวอย่างป้ายวงกลม/ใบเสียภาษี"
              previewUrl={CompulsoryImage}
              onChange={value => {
                const file = value.uploadFileForm?.get('files') as
                  | File
                  | undefined;

                setFilesToUpload({
                  ...filesToUpload,
                  carTaxStickerDocument: value.uploadFileForm,
                });

                setFileTax(file?.name || '');

                formik.setFieldValue('carTaxStickerDocument', {
                  image: file ? URL.createObjectURL(file) : '',
                });

                if (file) {
                  ocrTax(file);
                }
              }}
              onRemove={file => {
                if (!file.fileName?.startsWith('blob:')) {
                  setImageDeletionFiles(prev => [...prev, file]);
                }

                setFileTax('');
                formik.setFieldValue('carTaxStickerDocument', { image: '' });
              }}
              nameImage="รูปป้ายวงกลม/ใบเสียภาษี"
              pathImage={formik.values.carTaxStickerDocument.image}
              folder={folderType}
              isPdf={isPdfFile(fileTax)}
              fileName={fileTax}
            />
          </FormItem>

          <Divider />

          <FormItem
            labelCol={{ span: 24 }}
            colon={false}
            validateStatus={
              errors?.vehicleInsuranceDocument?.image ||
              formik.values.error?.actError
                ? 'error'
                : ''
            }
            help={
              formik.values.error?.actError ??
              errors?.vehicleInsuranceDocument?.image
            }
          >
            <UploadImageForm
              disabled={disableEdit || isApprovedAct}
              title="อัพโหลดรูป พรบ."
              statusDocs={statusAct || undefined}
              required
              bulletList={[
                'ไม่แก้ไขและตกแต่งรูป',
                'เห็นข้อมูลชัดเจนและครบถ้วน',
              ]}
              previewTitle="ตัวอย่าง พรบ."
              previewUrl={VehicleInsurnaceImage}
              onChange={value => {
                const file = value.uploadFileForm?.get('files') as
                  | File
                  | undefined;

                setFilesToUpload({
                  ...filesToUpload,
                  vehicleInsuranceDocument: value.uploadFileForm,
                });

                setFileAct(file?.name || '');

                formik.setFieldValue('vehicleInsuranceDocument', {
                  image: file ? URL.createObjectURL(file) : '',
                });

                if (file) {
                  ocrAct(file);
                }
              }}
              onRemove={file => {
                if (!file.fileName?.startsWith('blob:')) {
                  setImageDeletionFiles(prev => [...prev, file]);
                }

                setFileAct('');
                formik.setFieldValue('vehicleInsuranceDocument', { image: '' });
              }}
              nameImage="รูป พรบ."
              pathImage={formik.values.vehicleInsuranceDocument.image}
              folder={folderType}
              isPdf={isPdfFile(fileAct)}
              fileName={fileAct}
            />
          </FormItem>

          <Divider />

          <Title>ข้อมูลรถ </Title>
          <FormItem
            label="กรรมสิทธิ์เจ้าของรถ"
            required
            labelCol={{ span: 24 }}
            colon={false}
            validateStatus={
              shouldDisplayErrorMessage('ownership') ? 'error' : ''
            }
            help={shouldDisplayErrorMessage('ownership') && errors.ownership}
          >
            <Select
              disabled={disableEdit || isApprovedVehicle}
              size="large"
              showSearch
              placeholder="เลือกกรรมสิทธิ์เจ้าของรถ"
              optionFilterProp="children"
              options={vehicleType}
              // onBlur={formik.handleBlur}
              value={formik.values.ownership}
              // onChange={value => handleSelect('ownership', value)}
              onBlur={() => formik.setFieldTouched('ownership', true)}
              onChange={value => formik.setFieldValue('ownership', value)}
            />
          </FormItem>

          {formik.values.ownership === '3' && (
            <FormItem
              labelCol={{ span: 24 }}
              colon={false}
              validateStatus={
                shouldDisplayErrorMessage('consentFormDocument.image' as any)
                  ? 'error'
                  : ''
              }
              help={
                shouldDisplayErrorMessage('consentFormDocument.image' as any) &&
                consentFormError?.image
              }
            >
              <UploadImageForm
                disabled={disableEdit || isApprovedVehicle}
                title="อัพโหลดเอกสารยินยอมจากเจ้าของรถ"
                styleTitle={{
                  // same as TextRegular component
                  fontWeight: theme.fontWeight.regular,
                  fontStyle: 'normal',
                  fontSize: theme.fontSize.xs,
                  lineHeight: '22px',
                  margin: '0',
                }}
                required
                description="กรณีที่ผู้สมัครไม่ได้เป็นเจ้าของรถ:"
                bulletList={[
                  'มีใบลงนามยินยอมจากเจ้าของรถ',
                  'เห็นข้อมูลชัดเจนและครบถ้วน',
                  'เป็นภาพขาว-ดำได้',
                ]}
                previewTitle="ตัวอย่างเอกสารยินยอมจากเจ้าของรถ"
                previewUrl={ConsentImage}
                onChange={value => {
                  const files = value.uploadFileForm
                    ? (value.uploadFileForm.get('files') as Blob)
                    : '';
                  setFilesToUpload({
                    ...filesToUpload,
                    consentFormDocument: value.uploadFileForm,
                  });
                  formik.setFieldValue('consentFormDocument', {
                    image: files ? URL.createObjectURL(files) : '',
                  });
                }}
                onRemove={handleRemoveImage}
                nameImage="เอกสารยินยอมจากเจ้าของรถ"
                pathImage={formik?.values?.consentFormDocument?.image}
                folder={folderType}
                onChecked={consentFormDocument}
                renderCheckbox={{
                  name: 'isAllowConsent2',
                  text:
                    'ข้าพเจ้ารับรองว่าบุคคลเจ้าของรถอ่านประกาศเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล (Privacy Notice) ของผู้ประกอบการขนส่งที่ข้าพเจ้าสังกัดแล้ว',
                  onChecked: handleOnChecked2,
                  checked: consentFormDocument,
                  disabled: disableEdit,
                }}
                consent={{
                  title: 'ท่านยังไม่ได้ให้ความยินยอม',
                  content:
                    'โปรดรับรองว่าบุคคลเจ้าของรถอ่านประกาศเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล (Privacy Notice) ของผู้ประกอบการขนส่งที่ข้าพเจ้าสังกัดแล้ว',
                }}
              />
            </FormItem>
          )}

          <FormItem
            label="ประเภทรถ"
            required
            labelCol={{ span: 24 }}
            colon={false}
            validateStatus={
              shouldDisplayErrorMessage('serviceType') ? 'error' : ''
            }
            help={
              shouldDisplayErrorMessage('serviceType') && errors.serviceType
            }
          >
            <Select
              disabled={disableEdit || isApprovedVehicle}
              size="large"
              showSearch
              placeholder="เลือกประเภทรถ"
              optionFilterProp="children"
              options={truckType}
              // onBlur={formik.handleBlur}
              value={formik.values.serviceType}
              // onChange={value => handleSelect('serviceType', value)}
              onBlur={() => formik.setFieldTouched('serviceType', true)}
              onChange={value => formik.setFieldValue('serviceType', value)}
            />
          </FormItem>

          <FormItem
            label="ประเภทป้ายทะเบียนรถ"
            required
            labelCol={{ span: 24 }}
            colon={false}
            validateStatus={
              shouldDisplayErrorMessage('registrationType') ? 'error' : ''
            }
            help={
              shouldDisplayErrorMessage('registrationType') &&
              errors.registrationType
            }
          >
            <Select
              disabled={disableEdit || isApprovedVehicle}
              size="large"
              showSearch
              placeholder="เลือกประเภทป้ายทะเบียนรถ"
              optionFilterProp="children"
              options={plateColor}
              // onBlur={formik.handleBlur}
              value={formik.values.registrationType}
              // onChange={value => handleSelect('registrationType', value)x}
              onBlur={() => formik.setFieldTouched('registrationType', true)}
              onChange={value =>
                formik.setFieldValue('registrationType', value)
              }
            />
          </FormItem>

          <Divider />

          {/*<Title>ข้อมูล พรบ. </Title>*/}
          {/*<FormItem*/}
          {/*  label="ชื่อ - นามสกุล ผู้เอาประกันภัย"*/}
          {/*  required*/}
          {/*  labelCol={{ span: 24 }}*/}
          {/*  colon={false}*/}
          {/*  validateStatus={*/}
          {/*    shouldDisplayErrorMessage('ownerInsurance' as any) ? 'error' : ''*/}
          {/*  }*/}
          {/*  help={*/}
          {/*    shouldDisplayErrorMessage('ownerInsurance' as any) &&*/}
          {/*    errors.ownerInsurance*/}
          {/*  }*/}
          {/*>*/}
          {/*  <Input*/}
          {/*    disabled={true}*/}
          {/*    size="large"*/}
          {/*    name="ownerInsurance"*/}
          {/*    placeholder="กรอกชื่อ - นามสกุล ผู้เอาประกันภัย"*/}
          {/*    onChange={formik.handleChange}*/}
          {/*    onBlur={formik.handleBlur}*/}
          {/*    value={formik?.values?.ownerInsurance}*/}
          {/*  />*/}
          {/*</FormItem>*/}

          {/*<Title>ระยะเวลาเอาประกันภัย</Title>*/}

          {/*<Row gutter={16}>*/}
          {/*  <Col span={12}>*/}
          {/*    <FormItem*/}
          {/*      label="เริ่มต้นวันที่"*/}
          {/*      required*/}
          {/*      labelCol={{ span: 24 }}*/}
          {/*      colon={false}*/}
          {/*      validateStatus={*/}
          {/*        shouldDisplayErrorMessage('issueDate' as any) ? 'error' : ''*/}
          {/*      }*/}
          {/*      help={*/}
          {/*        shouldDisplayErrorMessage('issueDate' as any) &&*/}
          {/*        errors.issueDate*/}
          {/*      }*/}
          {/*    >*/}
          {/*      <Input*/}
          {/*        type="datetime-local"*/}
          {/*        disabled={disableEdit}*/}
          {/*        size="large"*/}
          {/*        name="issueDate"*/}
          {/*        placeholder={'Select datetime'}*/}
          {/*        onChange={formik.handleChange}*/}
          {/*        onBlur={formik.handleBlur}*/}
          {/*        value={convertToLocalDateTime(formik?.values?.issueDate)}*/}
          {/*      />*/}
          {/*    </FormItem>*/}
          {/*  </Col>*/}

          {/*  <Col span={12}>*/}
          {/*    <FormItem*/}
          {/*      label="ถึงวันที่"*/}
          {/*      required*/}
          {/*      labelCol={{ span: 24 }}*/}
          {/*      colon={false}*/}
          {/*      validateStatus={*/}
          {/*        shouldDisplayErrorMessage('expiryDate' as any) ? 'error' : ''*/}
          {/*      }*/}
          {/*      help={*/}
          {/*        shouldDisplayErrorMessage('expiryDate' as any) &&*/}
          {/*        errors.expiryDate*/}
          {/*      }*/}
          {/*    >*/}
          {/*      <Input*/}
          {/*        type="datetime-local"*/}
          {/*        disabled={disableEdit}*/}
          {/*        size="large"*/}
          {/*        name="expiryDate"*/}
          {/*        placeholder="กรุณาเลือกวันที่"*/}
          {/*        onChange={formik.handleChange}*/}
          {/*        onBlur={formik.handleBlur}*/}
          {/*        value={convertToLocalDateTime(formik?.values?.expiryDate)}*/}
          {/*      />*/}
          {/*    </FormItem>*/}
          {/*  </Col>*/}
          {/*</Row>*/}

          {/*<Row gutter={16}>*/}
          {/*  <Col span={12}>*/}
          {/*    <FormItem*/}
          {/*      label="วันทำสัญญาประกันภัย"*/}
          {/*      required*/}
          {/*      labelCol={{ span: 24 }}*/}
          {/*      colon={false}*/}
          {/*      validateStatus={*/}
          {/*        shouldDisplayErrorMessage('agreementMadeOn' as any)*/}
          {/*          ? 'error'*/}
          {/*          : ''*/}
          {/*      }*/}
          {/*      help={*/}
          {/*        shouldDisplayErrorMessage('agreementMadeOn' as any) &&*/}
          {/*        errors.agreementMadeOn*/}
          {/*      }*/}
          {/*    >*/}
          {/*      <Input*/}
          {/*        type="datetime-local"*/}
          {/*        disabled={disableEdit}*/}
          {/*        size="large"*/}
          {/*        name="agreementMadeOn"*/}
          {/*        placeholder={'Select datetime'}*/}
          {/*        onChange={formik.handleChange}*/}
          {/*        onBlur={formik.handleBlur}*/}
          {/*        value={convertToLocalDateTime(*/}
          {/*          formik?.values?.agreementMadeOn,*/}
          {/*        )}*/}
          {/*      />*/}
          {/*    </FormItem>*/}
          {/*  </Col>*/}

          {/*  <Col span={12}>*/}
          {/*    <FormItem*/}
          {/*      label="วันทำกรมธรรม์ประกันภัย"*/}
          {/*      required*/}
          {/*      labelCol={{ span: 24 }}*/}
          {/*      colon={false}*/}
          {/*      validateStatus={*/}
          {/*        shouldDisplayErrorMessage('policyIssuedOn' as any)*/}
          {/*          ? 'error'*/}
          {/*          : ''*/}
          {/*      }*/}
          {/*      help={*/}
          {/*        shouldDisplayErrorMessage('policyIssuedOn' as any) &&*/}
          {/*        errors.policyIssuedOn*/}
          {/*      }*/}
          {/*    >*/}
          {/*      <Input*/}
          {/*        type="datetime-local"*/}
          {/*        disabled={disableEdit}*/}
          {/*        size="large"*/}
          {/*        name="policyIssuedOn"*/}
          {/*        placeholder="กรุณาเลือกวันที่"*/}
          {/*        onChange={formik.handleChange}*/}
          {/*        onBlur={formik.handleBlur}*/}
          {/*        value={convertToLocalDateTime(formik?.values?.policyIssuedOn)}*/}
          {/*      />*/}
          {/*    </FormItem>*/}
          {/*  </Col>*/}
          {/*</Row>*/}

          {/*<Divider />*/}

          <Button
            block
            htmlType="submit"
            size="large"
            disabled={
              shouldDisabledSubmit() ||
              (isApprovedVehicle && isApprovedTax && isApprovedAct)
            }
            type={
              shouldDisabledSubmit() ||
              (isApprovedVehicle && isApprovedTax && isApprovedAct)
                ? 'default'
                : 'primary'
            }
            loading={saveLoading}
          >
            บันทึก
          </Button>
        </DriverPortalLayout>
        {formDirty && <ConfirmReturnModal isShow={isShowModal} />}
      </form>
    </>
  );
};

export default VehicleInformationPage;
